import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../Context";

function ViewHeader({ onToggleFullscreen, isFullscreen }) {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const { showTooltip, hideTooltip } = useContext(AppContext);
    const [fullscreen, setFullscreen] = useState(false);
    const exitRef = useRef(null);
    const homeRef = useRef(null);

    useEffect(() => {
        if (isFullscreen) {
            exitRef.current.style.display = "none";
            homeRef.current.style.justifyContent = "start";
            homeRef.current.style.paddingLeft = "20px";
            setFullscreen(true);
        } else if (!isFullscreen) {
            exitRef.current.style.display = "flex";
            homeRef.current.style.justifyContent = "center";
            homeRef.current.style.paddingLeft = "0px";
            setFullscreen(false);
        }
    }, [isFullscreen]);

    function onClick(id) {
        if (id == "fullscreen") {
            onToggleFullscreen();
        } else if (id == "home") {
            window.open("https://artistricks.com", "_self");
        }
    }

    return (
        <div className="ViewHeader">
            <div ref={exitRef} style={{ paddingLeft: "10px", width: "25%", height: "60%", display: "flex", justifyContent: "flex-start" }}>
                <img onMouseEnter={(e) => showTooltip(e, "Exit 3D Visualizer")} onMouseLeave={hideTooltip} className="ViewHeaderBtn" src={process.env.PUBLIC_URL + "/images/exitTiny.svg"} onClick={() => { onClick("exit") }}></img>
            </div>
            <div ref={homeRef} style={{ width: "50%", height: "90%", display: "flex", justifyContent: "center" }}>
                <img onMouseEnter={(e) => showTooltip(e, "Home")} onMouseLeave={hideTooltip} className="ViewHeaderBtn" src={process.env.PUBLIC_URL + "/images/logo.svg"} onClick={() => { onClick("home") }}></img>
            </div>
            <div style={{ paddingRight: "10px", width: "25%", height: "75%", display: "flex", justifyContent: "flex-end" }}>
                <img onMouseEnter={(e) => showTooltip(e, "Toggle Fullscreen")} onMouseLeave={hideTooltip} className="ViewHeaderBtn" src={`${process.env.PUBLIC_URL}/images/${fullscreen ? "normscreen" : "fullscreen"}.svg`} onClick={() => { onClick("fullscreen") }}></img>
            </div>
        </div>
    )
}
export default ViewHeader